import React, { useEffect } from 'react';
import { Route, Switch, Router, Redirect, useRoute } from 'wouter';

import ChevronRightSvg from '@/components/common/ChevronRightSvg';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';
import { Storage } from '@/tscapi/utils/browser-storage';
import { Cookie } from '@/tscapi/utils/cookie';
import { FavouriteStorage } from '@/tscapi/utils/favourites-storage';

import FavoriteIcon from '../../pdp/FavoriteIcon';
import { useAccount } from '../hooks/useAccount';
import { capitalizeLowercaseString } from '../utils/general.utils';

import ActiveLink from './ActiveLink';
import BackLink from './BackLink';

export const Navigation = () => {
    const [routeProfile, params1] = useRoute('/profile');
    const [routeNewsletter, params2] = useRoute('/newsletter');
    const [routePaymentCards, params3] = useRoute('/paymentcards');
    const [routeAddresses, params5] = useRoute('/addresses');
    const [routeEasyPay, params6] = useRoute('/easypay');
    const [routeAccount, params4] = useRoute('/');
    const isAuthenticated = useAuthenticated();
    const { data, isFetching } = useAccount(isAuthenticated);

    const doSignout = (e) => {
        e.preventDefault();
        const cookie = new Cookie();
        const storage = new Storage();
        const signoutMessage = "You've been signed out successfully";
        cookie.deleteTargetUrl();
        cookie.deleteUserToken();
        cookie.deleteUserEmail();
        cookie.deleteUserName();
        cookie.deleteLastName();
        cookie.deleteRedirectToCart();
        cookie.deleteModifyOrderInfo();
        cookie.deleteCartProductCount();
        cookie.deleteCartGuid();
        cookie.deletePaypalInfo();
        cookie.deleteRecentlyViewedItemNos();
        storage.deleteSessionCart();
        storage.deleteLocalReactQueryCache();
        storage.deleteLanguageForced();
        new FavouriteStorage().clear();
        cookie.SignOutMessage = signoutMessage;
        window.location.href = '/pages/signin';
    };

    return (
        <>
            {(routeProfile ||
                routeNewsletter ||
                routePaymentCards ||
                routeAccount ||
                routeAddresses ||
                routeEasyPay) && (
                <>
                    <div className="account__name" data-qm-encrypt="true">
                        {capitalizeLowercaseString(data.BillingAddress.FirstName)}
                        {"'s Account"}
                    </div>
                    <div className="account__number">
                        Customer # <b>{data.CustomerNo}</b>
                    </div>
                    <ul className={routeAccount ? 'account__nav root' : 'account__nav'}>
                        <li>
                            <div className="links__line"></div>
                        </li>
                        <li>
                            <ActiveLink className="links" href="/profile">
                                Your profile
                            </ActiveLink>
                        </li>
                        <li>
                            <ActiveLink className="links" href="/paymentcards">
                                Manage payment options
                            </ActiveLink>
                        </li>
                        <li>
                            <ActiveLink className="links" href="/easypay">
                                Your Easy Pay schedule
                            </ActiveLink>
                        </li>
                        <li>
                            <a className="links" href="/pages/myaccount/orderstatus">
                                Order status
                                <ChevronRightSvg />
                            </a>
                        </li>
                        <li>
                            <ActiveLink className="links" href="/addresses">
                                Manage addresses
                            </ActiveLink>
                        </li>

                        <li>
                            <a className="links" href="/pages/myaccount/recentlyviewed">
                                Recently viewed
                                <ChevronRightSvg />
                            </a>
                        </li>
                        <li>
                            <ActiveLink className="links" href="/newsletter">
                                Newsletter preferences
                            </ActiveLink>
                        </li>
                        <li>
                            <div className="links__line"></div>
                        </li>
                        <li>
                            <a className="links favourite" href="/pages/myaccount/favourites">
                                <FavoriteIcon width="20" height="20" /> Favourites
                            </a>
                        </li>
                        <li>
                            <div className="links__line"></div>
                        </li>
                        <li>
                            <a className="links signin" href="/pages/signin" onClick={(e) => doSignout(e)}>
                                Sign out
                            </a>
                        </li>
                    </ul>
                </>
            )}
            {(routeProfile || routeNewsletter || routePaymentCards || routeAddresses || routeEasyPay) && (
                <>
                    <div className="account__nav--mobile">
                        <li>
                            <div className="links__line"></div>
                        </li>
                        <li>
                            <BackLink className="links back" href="/">
                                Back to your account
                            </BackLink>
                        </li>
                        <li>
                            <div className="links__line"></div>
                        </li>
                    </div>
                </>
            )}
        </>
    );
};
